import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import Headline from "../../components/UI/Headline";
import MainArea from "../../components/UI/MainArea";
import { ResetAllParametersWithoutDeckblatt } from "../../store/resetParameters";

import {
  BemessungenMikropfaehle,
  selectBemessungenMikropfaehle,
  setBemessungenMikropfaehle,
} from "../../store/slices/bemessungenMikropfaehleSlice";

import {
  selectLogoImageBase64Url,
  selectPreparedByCompany,
  selectPreparedByCreatedAt,
  selectPreparedByUsername,
  selectProjectSubtitle,
  selectProjectText,
  selectProjectTitle,
  setCreatedAt,
  setLogoImageBase64Url,
  setPreparedByCompany,
  setPreparedByUsername,
  setProjectSubtitle,
  setProjectText,
  setProjectTitle,
} from "../../store/slices/deckblattSlice";
import { useGetProfileLogoQuery } from "../../services/API/ProfileAPI";

export default function Deckblatt() {
  const { t, i18n } = useTranslation("translation");
  const dispatch = useDispatch();

  const bemessungenMikropfaehle = Number(useSelector(selectBemessungenMikropfaehle));

  const title = useSelector(selectProjectTitle);
  const subtitle = useSelector(selectProjectSubtitle);
  const text = useSelector(selectProjectText);
  const preparedByCompany = useSelector(selectPreparedByCompany);
  const preparedByUsername = useSelector(selectPreparedByUsername);
  const logoBase64Url = useSelector(selectLogoImageBase64Url);
  const createdAt = useSelector(selectPreparedByCreatedAt);

  const { data: profileLogo, isLoading } = useGetProfileLogoQuery();

  const setMode = (e) => {
    dispatch(setBemessungenMikropfaehle(e));
  };

  const hasLogo = logoBase64Url !== "";
  // Hier ist richtig um Image anzuzeigen
  useEffect(() => {
    if (!isLoading && !logoBase64Url && "" !== profileLogo?.logoBase64Url) {
      dispatch(setLogoImageBase64Url(profileLogo?.logoBase64Url));
    }
  }, [isLoading, logoBase64Url]);

  return (
    <MainArea>
      <Headline isPrimary text={t("deckblatt.headline")} />

      <div className="row">
        <div className="col-md-12 mb-3">
          <div className="verticallyAligned">
            <input
              id="checkbox_EUROCODE_7"
              type="radio"
              name="mode"
              value={BemessungenMikropfaehle.EUROCODE_7}
              checked={
                bemessungenMikropfaehle === BemessungenMikropfaehle.EUROCODE_7 ? true : false
              }
              onChange={(e) => {
                dispatch(ResetAllParametersWithoutDeckblatt());
                setMode(e.target.value);
              }}
            />
            <label htmlFor="checkbox_EUROCODE_7">{t("deckblatt.eurocode")}</label>
          </div>
          <p>{t("deckblatt.eurocodeDetails_1")}</p>
        </div>

        <div className="col-md-12 mb-3">
          <div className="verticallyAligned">
            <input
              id="checkbox_GERMANY"
              type="radio"
              name="mode"
              value={BemessungenMikropfaehle.GERMANY}
              checked={bemessungenMikropfaehle === BemessungenMikropfaehle.GERMANY ? true : false}
              onChange={(e) => {
                dispatch(ResetAllParametersWithoutDeckblatt());
                setMode(e.target.value);
              }}
            />
            <label htmlFor="checkbox_GERMANY">{t("deckblatt.germany")}</label>
          </div>
          <p>{t("deckblatt.germanyDetails_1")}</p>
          <p>{t("deckblatt.germanyDetails_2")}</p>
          <p>{t("deckblatt.germanyDetails_3")}</p>
          <p>{t("deckblatt.germanyDetails_4")}</p>
          <p>{t("deckblatt.germanyDetails_5")}</p>
        </div>

        <div className="col-md-12 mb-3">
          <div className="verticallyAligned">
            <input
              id="checkbox_AASHTO"
              type="radio"
              name="mode"
              value={BemessungenMikropfaehle.AASHTO}
              checked={bemessungenMikropfaehle === BemessungenMikropfaehle.AASHTO ? true : false}
              onChange={(e) => {
                dispatch(ResetAllParametersWithoutDeckblatt());
                setMode(e.target.value);
              }}
            />
            <label htmlFor="checkbox_AASHTO">{t("deckblatt.aashto")}</label>
          </div>
          <p>{t("deckblatt.aashtoDetails_1")}</p>
        </div>

        <div className="col-md-12 mb-3">
          <div className="verticallyAligned">
            <input
              id="checkbox_FHWA"
              type="radio"
              name="mode"
              value={BemessungenMikropfaehle.FHWA}
              checked={bemessungenMikropfaehle === BemessungenMikropfaehle.FHWA ? true : false}
              onChange={(e) => {
                dispatch(ResetAllParametersWithoutDeckblatt());
                setMode(e.target.value);
              }}
            />
            <label htmlFor="checkbox_FHWA">{t("deckblatt.fhwa")}</label>
          </div>
          <p>{t("deckblatt.fhwaDetails_1")}</p>
        </div>
      </div>

      <div className="deckblat-form mt-5">
        <div className="row">
          <div className="col-md-4">
            <input
              placeholder={t("deckblatt.projectTitlePlaceholder")}
              type="text"
              className="form-control"
              value={title}
              onChange={(e) => {
                dispatch(setProjectTitle(e.target.value));
              }}
            />
            <input
              placeholder={t("deckblatt.projectSubtitlePlaceholder")}
              type="text"
              className="form-control"
              value={subtitle}
              onChange={(e) => {
                dispatch(setProjectSubtitle(e.target.value));
              }}
            />
            <textarea
              className="deckblatt-textarea"
              name=""
              id=""
              cols="55"
              rows="10"
              value={text}
              onChange={(e) => {
                dispatch(setProjectText(e.target.value));
              }}
            />
          </div>
        </div>
        {hasLogo && (
          <>
            <div className="row">
              <div className="col-4 mt-3 mb-3">
                <div>
                  <img className="border" src={logoBase64Url} style={{ width: "360px" }} alt="" />
                </div>
              </div>
            </div>
          </>
        )}
      </div>

      <div className="deckblat-form mt-5">
        <div className="row">
          <div className="col-md-4">
            <h3> {t("deckblatt.Prepared by")}</h3>
            <input
              placeholder={t("deckblatt.UserCompanyPlaceholder")}
              type="text"
              className="form-control"
              value={preparedByCompany}
              onChange={(e) => {
                dispatch(setPreparedByCompany(e.target.value));
              }}
            />
            <input
              placeholder={t("deckblatt.UserNamePlaceholder")}
              type="text"
              className="form-control"
              value={preparedByUsername}
              onChange={(e) => {
                dispatch(setPreparedByUsername(e.target.value));
              }}
            />

            <input
              placeholder={t("deckblatt.DateCreatedPlaceholder")}
              type="text"
              className="form-control"
              value={createdAt}
              onChange={(e) => {
                dispatch(setCreatedAt(e.target.value));
              }}
            />
          </div>
        </div>
      </div>

      <div className="copyright mt-5">
        <p style={{ fontSize: "0.8em", fontStyle: "italic" }}>{t("deckblatt.disclaimer")}</p>
      </div>
    </MainArea>
  );
}
